import {Grid, Typography, Link, ButtonBase} from "@mui/material";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const acciones = [
    {
        title: 'Para sistema de administración todo en uno para pymes:',
        buttonText: 'Sistematizar mi negocio',
        url: 'https://stokett.com'
    },
    {
        title: 'Para diseño de experiencia del cliente:',
        buttonText: 'Más información',
        url: 'https://digitalnexu.com/'
    }
];


const Home_Home = () => {

    const {sCell, masSM, sTab} = useResponsive()

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{ position: 'relative', overflow: 'hidden' }}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                size={{ xs: 12, sm: 12, md: 11 }}
                sx={{maxWidth: 1600, minHeight: '100vh', px: 3}}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"
                    size={{ xs: 12 }}
                    spacing={3}
                >
                    {acciones.map((item, index) => (
                        <Grid
                            key={index}
                            container
                            alignItems="center"
                            justifyContent="center"
                            size={{ xs: 12, sm: 12, md: 6 }}
                            sx={{ mb: 3 }}
                        >
                            <Grid
                                container
                                alignItems="center"
                                size={{ xs: 12 }}
                                sx={{backgroundColor: '#F4F4F4', borderRadius: 3, p: 3, minHeight: '200px'}}
                            >
                                <Grid container sx={{ pt: 2 }}>
                                    <Typography
                                        sx={{fontSize: 24, fontWeight: 500, color: '#575C65', textAlign: 'left'}}>
                                        {item.title}
                                    </Typography>
                                </Grid>

                                <Grid container size={{ xs: 12 }}>
                                    <ButtonBase
                                        sx={{
                                            background: '#fff',
                                            color: '#575C65',
                                            my: sCell ? 3 : 0,
                                            px: 4,
                                            py: 1.5,
                                            width: '250px',
                                            borderRadius: 2,
                                            textDecoration: 'none',
                                            transition: 'all 0.25s ease',
                                            '&:hover': {
                                                background: '#D8D8D8',
                                                textDecoration: 'none',
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0px 4px 14px rgba(0,0,0,0.08)'
                                            }
                                        }}
                                        href={item.url}
                                    >
                                        <Typography
                                            sx={{
                                                fontSize: 14,
                                                fontWeight: 800,
                                                color: '#575C65'
                                            }}
                                        >
                                            {item.buttonText}
                                        </Typography>
                                    </ButtonBase>
                                </Grid>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Grid>
    )

}
export default Home_Home